import { render, staticRenderFns } from "./BadicLayout.vue?vue&type=template&id=58e06cf6&scoped=true&"
import script from "./BadicLayout.vue?vue&type=script&lang=js&"
export * from "./BadicLayout.vue?vue&type=script&lang=js&"
import style0 from "./BadicLayout.vue?vue&type=style&index=0&id=58e06cf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e06cf6",
  null
  
)

export default component.exports